export async function copyDownloadUrl(url: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    const input = document.createElement('textarea');
    input.value = url;
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.append(input);
    input.select();

    try {
      return document.execCommand('copy');
    } catch {
      return false;
    } finally {
      input.remove();
    }
  }
}
